module.exports = __webpack_public_path__ + "static/media/w-5.47c19a30.svg";